import { useModal } from 'components/modal-views/context';

import Logo from 'layouts/logo/logo';
import UserIcon from 'components/icons/UserIcon';
import LogOutIcon from 'components/icons/LogOutIcon';
// @ts-ignore
import LogoSmallImage from 'assets/images/logo-small.svg';
import { MAIN_MENU_ITEMS } from 'site-settings/site-navigation';
import { useAppSelector } from 'redux/use-hooks';
import { selectAccountId } from 'redux/slices/account';

import {
  StyledNavBarWrapper,
  StyledNavigationBarList,
  StyledNavigationBarItem,
  StyledLink,
  StyledUserAccount,
  StyledBtn,
  StyledText
} from './navigation-bar.style';

const NavigationBar = () => {
  const { openModal } = useModal();
  const accountId = useAppSelector(selectAccountId);

  return (
    <StyledNavBarWrapper>
      <Logo imageUrl={LogoSmallImage} />
      <StyledNavigationBarList>
        {MAIN_MENU_ITEMS.map(({ id, href, target, text }) => (
          <StyledNavigationBarItem key={id}>
            <StyledLink href={href} target={target}>
              {text}
            </StyledLink>
          </StyledNavigationBarItem>
        ))}
      </StyledNavigationBarList>
      <StyledUserAccount>
        <StyledText>
          <UserIcon color="#329D9C" />
          {accountId}
        </StyledText>

        <StyledBtn onClick={() => openModal('LOGOUT_VIEW')}>
          <LogOutIcon color="#329D9C" /> Log Out
        </StyledBtn>
      </StyledUserAccount>
    </StyledNavBarWrapper>
  );
};

export default NavigationBar;
